<template>
  <div>
    <!-- 蒙层 -->
    <transition name="fade">
      <div class="mask" v-if="visible" @click="handleClose"></div>
    </transition>

    <transition name="slide-up">
      <div class="select-sms-activity" v-if="visible">
        <!-- 头部 -->
        <div class="header">
          <span class="header-title">{{ mergedTitle }}</span>
          <div class="header-actions">
            <span class="cancel-btn" @click="handleClose">取消</span>
            <span class="confirm-btn" @click="handleConfirm">确认</span>
          </div>
        </div>

        <!-- 表格区域 -->
        <div class="table-wrap">
          <el-table
            ref="table"
            border
            :data="tableData"
            style="width: 100%"
            max-height="280px"
            :row-key="getRowKey"
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="50" align="center" />
            <el-table-column
              v-for="(col, index) in mergedColumns"
              :key="index"
              :prop="col.prop"
              :label="col.label"
              :min-width="col.minWidth || 120"
              :show-overflow-tooltip="true"
              :formatter="col.formatter"
            />
            <template slot="empty">
              <div class="empty">
                <img
                  src="https://cdn-image.yucrm.cn/images/tb-front-platform/images/default/newNotData.png"
                  style="width: 186px; height: 114px"
                />
                <span class="empty-text">暂无数据</span>
              </div>
            </template>
          </el-table>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { getSelectData, getSelectDataJson } from "@/api/ai/newAi.js";
export default {
  name: "SelectSmsActivity",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "hd",
      validator: (val) => ["hd", "message"].includes(val),
    },
    msgId: {
      type: String,
      default: "",
    },
    conversationId: {
      type: String,
      default: "",
    },
    hasReChoose: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedRows: [],
      tableData: [],
    };
  },
  computed: {
    config() {
      const map = {
        hd: {
          title: "选择您需要分析的互动活动：",
          columns: [
            { prop: "activityName", label: "活动名称", minWidth: 180 },
            {
              prop: "activityCode",
              label: "活动类型",
              minWidth: 120,
              formatter: (row) => {
                return this.$getActivityNameByValue(row.activityCode);
              },
            },
          ],
        },
        message: {
          title: "选择您需要分析的短信活动：",
          columns: [
            { prop: "title", label: "活动主题", minWidth: 150 },
            { prop: "content", label: "短信内容", minWidth: 260 },
          ],
        },
      };
      return map[this.type] || map.hd;
    },
    mergedTitle() {
      return this.config.title;
    },
    mergedColumns() {
      return this.columns || this.config.columns;
    },
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    getRowKey() {
      return this.type == "hd" ? "id" : "batchId";
    },
  },
  created() {
    let fn = getSelectData;
    let id = this.msgId;
    if (this.hasReChoose) {
      fn = getSelectDataJson;
      id = this.conversationId;
    }
    fn(id).then((res) => {
      if (res.data) {
        if (this.hasReChoose) {
          this.tableData = JSON.parse(res.data.selectItemsDataJson);
        } else {
          this.tableData = JSON.parse(res.data);
        }
      }
    });
  },
  methods: {
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    handleClose() {
      this.visible = false;
      this.$emit("close");
    },
    handleConfirm() {
      if (!this.selectedRows.length) {
        const msg = this.type === "hd" ? "请选择互动活动!" : "请选择短信活动!";
        this.$message.warning(msg);
        return;
      }
      this.$emit("confirm", this.selectedRows);
      this.visible = false;
    },
  },
};
</script>

<style lang="scss" scoped>
// 蒙层
.mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: transparent;
  z-index: 2000;
}

// 过渡动画
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.select-sms-activity {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 2001;
  height: 350px;
  display: flex;
  flex-direction: column;
  background: linear-gradient(180deg, #eeeffe 0%, #f8fbfe 50%, #ffffff 100%);
  border-radius: 20px;
  padding: 20px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  flex-shrink: 0;
  &-title {
    font-size: 16px;
    font-weight: 600;
    color: #333;
  }
  &-actions {
    display: flex;
    gap: 16px;
  }
}

.cancel-btn {
  font-size: 14px;
  color: #666;
  cursor: pointer;
}

.confirm-btn {
  font-size: 14px;
  color: #3159ff;
  cursor: pointer;
  font-weight: 500;
}

.table-wrap {
  flex: 1;
  overflow: hidden;
  border-radius: 8px;

  /deep/ .el-table {
    font-size: 14px;
    color: #4c4c4c;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  /deep/ .el-table th,
  /deep/ .el-table td {
    border-right: 1px solid #e5e9f2;
  }

  /deep/ .el-table th {
    color: #333;
    font-weight: 500;
    border-bottom: 1px solid #e5e9f2;
  }

  /deep/ .el-table td {
    padding: 8px 0;
    border-bottom: 1px solid #e5e9f2;
  }

  /deep/ .el-table__body-wrapper {
    overflow-y: auto;
    &::-webkit-scrollbar-thumb {
      background-color: #efefef;
    }
    &::-webkit-scrollbar-track {
      background-color: transparent;
    }
  }

  /deep/ .el-table__empty-block {
    width: 100%;
  }

  /deep/ .el-table__empty-text {
    width: 100%;
  }
}

// 过渡动画
.slide-up-enter-active,
.slide-up-leave-active {
  transition: transform 0.3s ease;
}

.slide-up-enter,
.slide-up-leave-to {
  transform: translateY(100%);
}

.empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  &-text {
    font-weight: 400;
    font-size: 12px;
    color: #8186a5;
  }
}
</style>
